import React from "react";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import Select from "react-select";

interface FilterOption {
  label: string;
  value: string;
}

interface FilterPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: () => void;
  onClear: () => void;
  title?: string;
  filters: {
    label: string;
    value: any;
    options: FilterOption[];
    onChange: (selected: any) => void;
  }[];
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  isOpen,
  onClose,
  onApply,
  onClear,
  title = "Filters",
  filters,
}) => {
  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="filter-overlay"
          onClick={onClose}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1040,
            transition: "opacity 0.3s ease",
          }}
        />
      )}

      {/* Filter Panel */}
      <div
        className="filter-panel"
        style={{
          position: "fixed",
          top: 0,
          right: isOpen ? 0 : "-25%",
          width: "25%",
          height: "100vh",
          backgroundColor: "#fff",
          boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.1)",
          zIndex: 1050,
          transition: "right 0.3s ease",
          overflowY: "auto",
        }}
      >
        <Card className="border-0" style={{ height: "auto", minHeight: "100vh" }}>
          <CardHeader
            className="d-flex justify-content-between align-items-center bg-primary text-white"
            style={{ 
              borderBottom: "1px solid #dee2e6",
              padding: "1rem 1.25rem"
            }}
          >
            <h5 className="mb-0 text-white fw-semibold">{title}</h5>
            <Button
              className="text-white"
              onClick={onClose}
              style={{ 
                opacity: 1,
                background: "transparent",
                border: "none",
                padding: "0.25rem 0.5rem",
                fontSize: "1.25rem"
              }}
            >
              <i className="ri-close-line"></i>
            </Button>
          </CardHeader>
          <CardBody className="p-4">
            <div className="d-flex flex-column gap-4">
              {filters.map((filter, index) => (
                <div key={index}>
                  <label className="form-label fw-semibold mb-2" style={{ color: "#495057", fontSize: "0.875rem" }}>
                    {filter.label}
                  </label>
                  <Select
                    value={
                      filter.value
                        ? { label: filter.value, value: filter.value }
                        : null
                    }
                    onChange={filter.onChange}
                    options={filter.options}
                    isClearable
                    placeholder={`Select ${filter.label}`}
                    className="react-select"
                    classNamePrefix="select"
                    styles={{
                      control: (base: any) => ({
                        ...base,
                        minHeight: "42px",
                        borderColor: "#ced4da",
                        borderRadius: "8px",
                        "&:hover": {
                          borderColor: "#adb5bd"
                        }
                      }),
                      placeholder: (base: any) => ({
                        ...base,
                        color: "#6c757d"
                      })
                    }}
                  />
                </div>
              ))}
            </div>

            <div className="d-flex gap-3 mt-5 pt-4 border-top">
              <Button
                color="secondary"
                outline
                className="flex-fill"
                onClick={onClear}
                style={{
                  borderRadius: "8px",
                  padding: "0.625rem",
                  fontWeight: "500",
                  fontSize: "0.9375rem",
                  backgroundColor: "transparent",
                  color: "#6c757d"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#6c757d";
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#6c757d";
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
              >
                Clear
              </Button>
              <Button
                color="primary"
                className="flex-fill"
                onClick={onApply}
                style={{
                  borderRadius: "8px",
                  padding: "0.625rem",
                  fontWeight: "500",
                  fontSize: "0.9375rem"
                }}
              >
                Apply
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default FilterPanel;

